<ng-template [ngIf]="debug$ | async">
  <div class="debug">
    <div>
      <strong>Debug info</strong>
      <ng-template [ngIf]="debugInfo?.selectedFeaturings?.length">
        <ng-container *ngFor="let item of debugInfo?.selectedFeaturings; trackBy: trackByFn">
          <a *ngIf="item.purl" [href]="item.purl">[⚠️] Panel</a>
        </ng-container>
      </ng-template>
    </div>
    <pre>contentFilter: {{ contentFilter | json }}</pre>
    <hr/>
    <pre>{{ debugInfo | json }}</pre>
    <div *ngIf="!loading && !panesList">No panes configured</div>
  </div>
</ng-template>
<div class="schools" [class.mobile]="deviceService.isMobile()">
  <div class="header-wrap">
    <app-library-header></app-library-header>
  </div>

  <ng-template [ngIf]="displayList && stabHidden">
      <app-pane *ngFor="let pane of panesList; trackBy: trackByFn" [item]="pane" (loadFinished)="setStabVisible(pane, $event)"></app-pane>
  </ng-template>
</div>
<ng-template [ngIf]="!stabHidden">
  <app-filter-cleaning></app-filter-cleaning>
</ng-template>
